/**
 * @功能名称: 移除给定对象中的空值，修改原对象，按照option中的优先级去重,opt支持多层结构
 * @文件名称: removeNull.js
 * @params: Object | [Array]
 * @Date: 2018/6/13 下午3:21.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
function loop(opt, obj) {
  if(Array.isArray(opt)){
    if(Array.isArray(opt[0])){
      opt.forEach(item=>{
        obj = loop(item, obj)
      })
      return obj
    }else {
      let flag = false;
      opt.forEach(key=>{
        if(obj[key] || obj[key] === 0){
          if(flag){
            delete obj[key]
          }
          flag = true
        }
      })
      return obj
    }
  }else {
    return obj
  }
}
export default function (obj, opt) {
  for (let key in obj){
    if(!obj[key] && obj[key] !== 0 && obj[key] !== false && obj[key] !== ''){
      delete obj[key]
    }
  }
 return loop(opt, obj)
}
